import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AuthGuard, I18nModule, UrlModule } from '@spartacus/core';
import { CmsPageGuard, IconModule, MediaModule } from '@spartacus/storefront';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KbCustomerIdDropdownModule } from '../kb-myAccount/kb-MyOwnPartNumbers/customer-id-drop-down/customer-id-drop-down.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SavedShoppingCartComponent } from './saved-shopping-cart/saved-shopping-cart.component';
import { DeleteSavedCartDialogComponent } from './delete-saved-cart-dialog/delete-saved-cart-dialog.component';
import { RestoreSavedCartDialogComponent } from './restore-saved-cart-dialog/restore-saved-cart-dialog.component';
import { SaveCartDetailsComponent } from './save-cart-details/save-cart-details.component';
import { SavedCartService } from '@spartacus/cart/saved-cart/core';
import { KbMyAccountLeftSideNavModule } from '../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';
import { KbLoaderModule } from '../loader/loader.module';
@NgModule({
  declarations: [
    SavedShoppingCartComponent,
    DeleteSavedCartDialogComponent,
    RestoreSavedCartDialogComponent,
    SaveCartDetailsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MediaModule,
    KbCustomerIdDropdownModule,
    KbMyAccountLeftSideNavModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    KbPaginationModule,
    KbLoaderModule,
    RouterModule.forChild([
      {
        path: 'saved-carts/:cartId',
        data: { pageLabel: '/saved-carts' },
        component: SaveCartDetailsComponent,
        canActivate: [CmsPageGuard, AuthGuard],
      },
    ]),
  ],
  providers: [SavedCartService],
})
export class KbSavedShoppingCartModule { }
